export function getAgentInfo() {
  return {
    first_name: window?.ixn_data?.IXNModel?.agent?.first_name || window?.EditQuoteModel?.IXNQuote?.IXNModel?.agent?.first_name || window?.ixnDataModel?.IXNModel?.agent?.first_name || '',
    last_name: window?.ixn_data?.IXNModel?.agent?.last_name || window?.EditQuoteModel?.IXNQuote?.IXNModel?.agent?.last_name || window?.ixnDataModel?.IXNModel?.agent?.last_name || '',
    email: window?.ixn_data?.IXNModel?.agent?.email || window?.EditQuoteModel?.IXNQuote?.IXNModel?.agent?.email || window?.ixnDataModel?.IXNModel?.agent?.email || '',
    phone: window?.ixn_data?.IXNModel?.agent?.phone || window?.EditQuoteModel?.IXNQuote?.IXNModel?.agent?.phone || window?.ixnDataModel?.IXNModel?.agent?.phone || ''
  };
}
